import { useQuery } from 'react-query';

import { getList as queryFn } from 'api/endPoints/getList';

import { IGetNotificationsResponse } from 'components/App/AuthenticateLayout/Header/Notification/Notifications.types';

export const useQueryGetNotifications = () => {
    return useQuery<IGetNotificationsResponse[], QueryError>('useQueryGetNotifications', queryFn);
};
